export enum FormType
{
    LCR = 1,
    ER = 2,
    LL = 3,
    ORDER = 4,
    BNCC = 5,
    ESG = 6
}